import * as Yup from 'yup'

export const initialSuperEndDryValues = {
  dryName: '',
  dryDate: '',
  dryShift: '',
  dryMessage: '',
  dryAlarmNotice: '',
  dryBrokenStateSeals: '',
  evapComments: '',
  evapCurrentTurboFan: '',
  palletIdsReconedOnShift: '',
  threePalletsReconed: '',
  threePalletsReconedWhyNot: '',
  reconEquipmentClean: '',
  reconRmClean: '',
  reconDrainLineEmpty: '',
  reconCleanWhyNot: '',
  cityWaterFlow: '',
  waterSiloWashed: '',
  evapHistRegulatoryIssues: '',
  dryerComments: '',
  mpcDryerComments: '',
  pwdPackagingComments: '',
  pwdPalletsProduced: '',
  pwdSealChecksPerformed: '',
  pwdSealChecksFailed: '',
  pwdPrintChecksPerformed: '',
  pwdPrintChecksFailed: '',
  pwdAvgPrintQuality: '',
  mpcPackagingComments: '',
  mpcPalletsProduced: '',
  mpcSealChecksPerformed: '',
  mpcSealChecksFailed: '',
  mpcPrintChecksPerformed: '',
  mpcPrintChecksFailed: '',
  mpcAvgPrintQuality: '',

  dryGmpViolations: '',
  dryGmpViolationComments: '',
  dryAuditDate: '',
  dryAuditTasksCompleted: '',
  dryUsdaAuditTasksCompleted: '',
}

export const SuperEndDrySchema = Yup.object().shape({
  logId: Yup.string(),
  dryName: Yup.string(),
  dryDate: Yup.string(),
  dryShift: Yup.string(),
  dryMessage: Yup.string(),
  dryAlarmNotice: Yup.string(),
  dryBrokenStateSeals: Yup.string(),
  evapComments: Yup.string(),
  evapCurrentTurboFan: Yup.string(),
  palletIdsReconedOnShift: Yup.string(),
  threePalletsReconed: Yup.string(),
  threePalletsReconedWhyNot: Yup.string(),
  reconEquipmentClean: Yup.string(),
  reconRmClean: Yup.string(),
  reconCleanWhyNot: Yup.string(),
  cityWaterFlow: Yup.string(),
  waterSiloWashed: Yup.string(),
  evapHistRegulatoryIssues: Yup.string(),
  dryerComments: Yup.string(),
  mpcDryerComments: Yup.string(),
  pwdPackagingComments: Yup.string(),
  pwdPalletsProduced: Yup.string(),
  pwdSealChecksPerformed: Yup.string(),
  pwdSealChecksFailed: Yup.string(),
  pwdPrintChecksPerformed: Yup.string(),
  pwdPrintChecksFailed: Yup.string(),
  pwdAvgPrintQuality: Yup.string(),
  mpcPackagingComments: Yup.string(),
  mpcPalletsProduced: Yup.string(),
  mpcSealChecksPerformed: Yup.string(),
  mpcSealChecksFailed: Yup.string(),
  mpcPrintChecksPerformed: Yup.string(),
  mpcPrintChecksFailed: Yup.string(),
  mpcAvgPrintQuality: Yup.string(),

  dryGmpViolations: Yup.string(),
  dryGmpViolationComments: Yup.string(),
  dryAuditDate: Yup.string(),
  dryAuditTasksCompleted: Yup.string(),
  dryUsdaAuditTasksCompleted: Yup.string(),
})
